module.exports = __webpack_public_path__ + "arvr-439b2a28.webp";